import React, { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { StoreContext } from "../../../store/StoreContext";
import { handleCleanTitle } from "../../../helpers";
import { Accordion, ListGroup } from "react-bootstrap";
import { localSession } from "../../../helpers/local-storage";
import { LOCAL_SESSION } from "../../../constants/local-entity";
import "./inspections.scss";

const Inspections = () => {
  const navigate = useNavigate();
  const { setAppTitle, formsAD, formsP, formsAM } = useContext(StoreContext);

  const sessionData = useMemo(() => localSession.getItem(LOCAL_SESSION), []);
  const assignedCenters = sessionData?.assignedCenters || [];

  const hasCentro = (name) => {
    if (Number(sessionData?.profile) === 1) return true;
    if (assignedCenters.length === 0) return true;
    return assignedCenters.some(c => c.centro === name);
  };

  const [searchValue, setSearchValue] = useState("");
  const [formsADByRol, setFormsADByRol] = useState([]);
  const [formsAMByRol, setFormsAMByRol] = useState([]);
  const [formsPByRol, setFormsPByRol] = useState([]);
  const [activeKey, setActiveKey] = useState(["0", "1", "2"]);

  useEffect(() => {
    setAppTitle("Reunión preoperacional");
  }, []);

  useEffect(() => {
    if (!formsAD || !formsAM || !formsP) {
      console.warn("Datos insuficientes para filtrar");
      return;
    }

    const _ad = formsAD.filter(({ Titulo }) => Titulo.includes("Reunión preoperacional"));
    const _am = formsAM.filter(({ Titulo }) => Titulo.includes("Reunión preoperacional"));
    const _p = formsP.filter(({ Titulo }) => Titulo.includes("Reunión preoperacional"));

    setFormsADByRol(_ad);
    setFormsAMByRol(_am);
    setFormsPByRol(_p);
  }, [formsAD, formsAM, formsP]);

  return (
    <>


      <div className="row">
        <div className="col-12">
          <Accordion defaultActiveKey={["0", "1", "2"]} alwaysOpen>
            {hasCentro("Agua Dulce") && (
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span className="text-primary-cermaq h5 mb-0">AGUA DULCE</span>
                </Accordion.Header>
                <Accordion.Body>
                  {formsADByRol.length === 0 ? <p>No hay datos</p> : (
                    <ListGroup variant="flush">
                      {formsADByRol.map((form, index) => (
                        <ListGroup.Item
                          key={`${form.TemplateId}-${index}`}
                          className="form-item"
                          onClick={() => navigate("Jefatura/forms/" + form.TemplateId)}
                        >
                          {handleCleanTitle(form.Titulo)}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )}
            {hasCentro("Agua Mar") && (
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span className="text-primary-cermaq h5 mb-0">AGUAMAR</span>
                </Accordion.Header>
                <Accordion.Body>
                  {formsAMByRol.length === 0 ? <p>No hay datos</p> : (
                    <ListGroup variant="flush">
                      {formsAMByRol.map((form, index) => (
                        <ListGroup.Item
                          key={`${form.TemplateId}-${index}`}
                          className="form-item"
                          onClick={() => navigate("Jefatura/forms/" + form.TemplateId)}
                        >
                          {handleCleanTitle(form.Titulo)}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )}
            {hasCentro("Procesos") && (
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <span className="text-primary-cermaq h5 mb-0">PROCESOS</span>
                </Accordion.Header>
                <Accordion.Body>
                  {formsPByRol.length === 0 ? <p>No hay datos</p> : (
                    <ListGroup variant="flush">
                      {formsPByRol.map((form, index) => (
                        <ListGroup.Item
                          key={`${form.TemplateId}-${index}`}
                          className="form-item"
                          onClick={() => navigate("Jefatura/forms/" + form.TemplateId)}
                        >
                          {handleCleanTitle(form.Titulo)}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default Inspections;
